import { render, staticRenderFns } from "./AppInactiveAffiliate.vue?vue&type=template&id=4d24acf6"
import script from "./AppInactiveAffiliate.vue?vue&type=script&lang=js"
export * from "./AppInactiveAffiliate.vue?vue&type=script&lang=js"
import style0 from "./AppInactiveAffiliate.vue?vue&type=style&index=0&id=4d24acf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports